import type { TowerDesign } from "@/game/towerSpec";
/** EXACT: 120ft self-support, A36 steel, 90 mph, 0.75in ice. Face taper estimated base ~10ft/top ~3.5ft. */
export const design: TowerDesign = {
  id: "selfsupport-sullivan-120ft",
  name: "Self-Support (Sullivan 120 ft, WI)",
  description: "Real 120 ft self-support tower, Sullivan WI (A36, 90 mph, 0.75in ice).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "lattice",
    height: 36.58,
    stack: { faces: 3, panels: 12, baseRadius: 1.76, topRadius: 0.62,
      legSection: "legHeavy", braceSection: "braceMed", legMaterial: "a36", braceMaterial: "a36", bracing: "X" },
    foundation: { soil: "dense-sand", base: { type: "pad", width: 2.5, diameter: 1, depth: 2.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 8, bolt: "b1_5", grade: "f1554_55", boltCircleDia: 0.7, embedment: 0.8, edgeDistance: 0.35, platePlanArea: 0.5, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6 } },
  },
};
